import React from 'react';

type StripeTone = 'green' | 'yellow' | 'red';

const STRIPES: Record<StripeTone, string> = {
  green: 'repeating-linear-gradient(-45deg, #8ed96f 0 12px, #c6f5b0 12px 24px)',
  yellow: 'repeating-linear-gradient(-45deg, #ffe58a 0 12px, #f6c94a 12px 24px)',
  red: 'repeating-linear-gradient(-45deg, #f6a090 0 12px, #e86b56 12px 24px)',
};

const CaptureStripeHeader: React.FC<{ tone: StripeTone; title: string }> = ({ tone, title }) => (
  <div className="relative w-full h-[96px] flex items-center justify-center" style={{ background: STRIPES[tone] }}>
    <p className="relative text-center font-black tracking-wide text-3xl sm:text-4xl text-sd-ink">{title}</p>
  </div>
);

export default CaptureStripeHeader;
